import {
  ILibrarySelectionOption,
  ISelectionOption,
  ISelectionUploadedFile,
  ISelectionUploadingFile,
} from 'redux-store/api/selections';
import { v4 as uuidV4 } from 'uuid';

export const getSortedOptions = <T extends ILibrarySelectionOption = ISelectionOption>(
  options: T[]
): T[] => {
  const newOptions = [...options];

  return newOptions.sort((a, b) => a.orderNo - b.orderNo);
};

export const getSelectionDefaultUploads = (
  uploads?: ISelectionUploadedFile[]
): ISelectionUploadingFile[] => {
  if (!uploads?.length) {
    return [];
  }

  return uploads.map(({ id, name, url, mimeType }) => ({
    id,
    url,
    name,
    mimeType,
    status: 'done',
    percent: 100,
    tempId: uuidV4(),
  }));
};

export const ensureHttpUrl = (url: string) => {
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  return url;
};
